export { default } from './AllergyPopup';
